<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="header-side"></div>
    <div class="dialog-title-text" cdkDragHandle>
        Additional Streams
    </div>
    <button mat-icon-button class="close-btn" (click)="onCancel()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <form class="form-grid" [formGroup]="upsertDepackStream">
        <div class="form-grid-row">
            <app-select-search (selectedItemId)="onStreamReceived($event)" [selectItems]="selectStreamItems"
            [isrequired]="true" [matcher]="matcher"
            [invalid]="!!(upsertDepackStream.get('streamId')?.invalid && (upsertDepackStream.get('streamId')?.touched || attemptSave()))"
            formControlName="streamId" selectTitle="Stream" [setId]="streamId"></app-select-search>
        </div>
        <div class="form-grid-row">
            <mat-form-field appearance="outline">
                <mat-label> UOM</mat-label>
                <mat-select data-testid="tipFee_UOM_Id" formControlName="tipFee_UOM_Id"
                    name="tipFee_UOM_Id">
                    <mat-option [value]="null">-Select UOM-</mat-option>
                    @for (uom of uomsLookup; track uom.id) {
                    <mat-option [value]="uom.id">{{ uom.name }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Tip Fee</mat-label>
                <input data-testid="tipFee" matInput type="text"  name="tipFee" formControlName="tipFee" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Quantity</mat-label>
                <input data-testid="quantity" matInput type="text" name="quantity" formControlName="quantity" (input)="roundOff($event, 99999, 4, 'quantity')" />
            </mat-form-field>
        </div>
        <div class="form-grid-row">
            <mat-form-field appearance="outline">
                <mat-label> Rebate UOM</mat-label>
                <mat-select data-testid="rebate_UOM_Id" formControlName="rebate_UOM_Id"
                    name="rebate_UOM_Id">
                    <mat-option [value]="null">-Select UOM-</mat-option>
                    @for (uom of uomsLookup; track uom.id) {
                    <mat-option [value]="uom.id">{{ uom.name }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Rebate Amount</mat-label>
                <input data-testid="rebateValue" matInput type="text" name="rebateValue" formControlName="rebateValue" (input)="roundOff($event, 99999, 4, 'rebateValue')" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Rebate Quantity</mat-label>
                <input data-testid="rebateQuantity" matInput type="text" name="rebateQuantity"
                    formControlName="rebateQuantity" (input)="roundOff($event, 99999, 4, 'rebateQuantity')" />
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
    <button mat-raised-button color="primary" mat-primary (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" mat-primary data-testid="btnaddtStreamSave" (click)="onSave()">Save</button>
</mat-dialog-actions>